import * as types from './constants';

const initialState = {
  data: {},
  resetLoading: false,
  errors_api: {}
};

const actions = {
  // Reset Account Password
  [types.RESET_ACCOUNT_PASSWORD_REQUEST]: state => {
    const data = {
      ...state,
      resetLoading: true
    };

    return { ...data };
  },

  [types.RESET_ACCOUNT_PASSWORD_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      resetLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.RESET_ACCOUNT_PASSWORD_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      resetLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.RESET_ACCOUNT_PASSWORD_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};